export class Serie {
    description: string;
    episodes: Array<string>;
    folderName: string;
    name: string;
    order: number;
    thumbnail: string
}
